export enum TDeviceTimeoutScale {
  Seconds,
  Minutes,
  Hours,
  Days,
}
